import { useEffect, useState } from 'react';
import { MdOutlineVerifiedUser } from 'react-icons/md';
import { CovalentBalanceItem } from '@shared/types/frontend';
import TruncatedText from './TruncatedText';
import classNames from '@/lib/misc/classNames';
import { getNetworkLogo } from '@/lib/misc/tokenImageHelper';
import TokenImage from './TokenImage';
interface AssetLogoProps {
  asset: Partial<CovalentBalanceItem>;
  className?: string;
  withTickerSymbol?: boolean;
  variant?: 'table';
  showName?: boolean;
  truncate?: boolean;
  showNetwork?: boolean;
  symbolSectionClassName?: string;
  verified?: boolean;
  hideTickerSymbol?: boolean;
  assetNameClass?: string;
}
const AssetLogo = ({
  asset,
  withTickerSymbol = false,
  variant,
  className,
  showName = false,
  truncate = true,
  showNetwork = false,
  symbolSectionClassName,
  verified = false,
  hideTickerSymbol = false
}: AssetLogoProps) => {
  const {
    contract_address,
    network,
    logo_url,
    contract_ticker_symbol,
    contract_name,
    contract_display_name
  } = asset;
  const [logoUrl, setLogoUrl] = useState(logo_url);
  useEffect(() => {
    if (asset) {
      setLogoUrl(asset.logo_url);
    }
  }, [asset]);
  return <div className={classNames('flex items-center h-fit w-fit flex-shrink-0', className)} key={`${contract_address}-${network}-${logoUrl}`} data-sentry-component="AssetLogo" data-sentry-source-file="AssetLogo.tsx">
      <div className='relative'>
        <TokenImage mainImageSrc={logoUrl} badgeImageSrc={showNetwork ? getNetworkLogo(network) : null} size={32} badgeSize={16} data-sentry-element="TokenImage" data-sentry-source-file="AssetLogo.tsx" />
        {verified && <div className='absolute top-[-4px] right-[-4px] bg-[#34D399] rounded-full w-5 h-5 flex justify-center items-center'>
            <MdOutlineVerifiedUser className='text-white' size={14} />
          </div>}
      </div>
      {(withTickerSymbol || variant === 'table' || showName) && <div className={classNames('flex flex-col', {
      'items-start ml-4': variant === 'table'
    }, symbolSectionClassName)}>
          {(contract_name || contract_display_name) && showName && <TruncatedText text={contract_name || contract_display_name} className={classNames('text-genius-cream text-base font-medium max-lg:text-sm shrink-0')} count={8} truncate={truncate} />}
          {!hideTickerSymbol && <TruncatedText text={contract_ticker_symbol} className={classNames('text-xs ml-2', {
        'text-genius-cream/60 ml-0': variant === 'table'
      })} truncate={truncate} />}
        </div>}
    </div>;
};
export default AssetLogo;